import React, { PureComponent } from 'react';

import ChangePassword from '../auth/change-password';
import SwitchOffice from './switch-office';

export default class Profile extends PureComponent {
  render() {
    return (
      <>
        <SwitchOffice />
        <ChangePassword />
      </>
    );
  }
}
